import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ApplicationProvider from './context/';
import './style.css';

ReactDOM.render(
  <React.StrictMode>
    <ApplicationProvider>
      <App />
    </ApplicationProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
